/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class HighFrequencyIntervalConfig {
  'intervalMinutes': HighFrequencyIntervalConfigIntervalMinutesEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "intervalMinutes",
      "baseName": "intervalMinutes",
      "type": "HighFrequencyIntervalConfigIntervalMinutesEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return HighFrequencyIntervalConfig.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum HighFrequencyIntervalConfigIntervalMinutesEnum {
  NUMBER_30 = 30,
  NUMBER_60 = 60,
  NUMBER_120 = 120,
  NUMBER_180 = 180,
  NUMBER_240 = 240,
  NUMBER_360 = 360,
  NUMBER_480 = 480,
  NUMBER_720 = 720
}

